import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/Company/CompanyForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { CompanyForm } from '../../../forms/Company/CompanyForm';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { paths } from '../../RouterContainer';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { useTranslation } from '../../../context/translationContext';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component represents Teams overview for current user
 */
export const UserCompaniesCreatePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { company, changeCompany } = useCurrentCompany();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  useEffect(() => {
    setBreadcrumbs([
      { path: `${paths.MY_COMPANIES}`, name: 'navigation.my-companies' },
      { path: `${paths.MY_COMPANIES}/create`, name: 'navigation.my-companies-create' },
    ]);
  }, []);
  /**
   * Handles create action for new company form submit.
   * Uses company create API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPost({ url: apiUrl.COMPANY_CREATE, data: values });
      if (response?.status === 201) {
        stopLoading();
        // žádná selectnutá company - selectnout nově přidanou
        if (!company) changeCompany(response.data);
        toast.success('Success!');
        navigate(`/${paths.MY_COMPANIES}/edit/${response.data?.id}`);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  const _initialValues: Values = {
    name: '',
    description: '',
    supplierAddressLine1: '',
    supplierAddressLine2: '',
    supplierAddressCity: '',
    supplierAddressPostCode: '',
    supplierAddressCountry: '',
    supplierCompanyId: '',
    supplierVatId: '',
    codeBookItemsUseCode: false,
    maxDecimalNumUnitPrice: 2,
  };

  return (
    <div className="w-full space-y-8">
      <h1 className="text-3xl font-bold">{t('page.company.headline-create')}</h1>
      <CompanyForm onSubmit={handleSubmit} initialValues={_initialValues} />
    </div>
  );
};
